function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  id: "Layer_1-2"
}, React.createElement("circle", {
  fill: "#848890",
  cx: 9,
  cy: 9,
  r: 9
}), React.createElement("rect", {
  x: 3,
  y: 8,
  fill: "#FFFFFF",
  width: 2,
  height: 2
}), React.createElement("rect", {
  x: 8,
  y: 8,
  fill: "#FFFFFF",
  width: 2,
  height: 2
}), React.createElement("rect", {
  x: 13,
  y: 8,
  fill: "#FFFFFF",
  width: 2,
  height: 2
})));

function SvgMeatballs(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/meatballs.0d84eded.svg";
export { SvgMeatballs as ReactComponent };